import React, { useState } from 'react';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

const PREVIEW_COUNT = 1;

function PointsOfPerformance({ points = '' }) {
    const [expanded, setExpanded] = useState(false);

    const pointsList = points
        ? points
              .split(/\r?\n/)
              .map(p => p.trim())
              .filter(Boolean)
        : [];

    const visiblePoints = expanded
        ? pointsList
        : pointsList.slice(0, PREVIEW_COUNT);
    const hasMore = pointsList.length > PREVIEW_COUNT;

    const toggleExpanded = () => setExpanded(prev => !prev);

    return (
        <div className="points-of-performance-container">
            <button
                className="points-of-performance-header"
                onClick={toggleExpanded}
            >
                <span className="points-of-performance-label">
                    Points of Performance
                </span>
                {expanded ? <ExpandMoreIcon /> : <ChevronRightIcon />}
            </button>
            <ul className="points-of-performance-list" onClick={toggleExpanded}>
                {visiblePoints.map(point => <li key={point}>{point}</li>)}
                {!expanded &&
                    hasMore && (
                        <li className="points-of-performance-ellipsis">…</li>
                    )}
            </ul>
        </div>
    );
}

export default PointsOfPerformance;
